import React, { useState } from "react";

import DischargeTemplateUpload from "./DischargeTemplateUpload";
import DischargeTemplateList from "./DischargeTemplateList";

/**
 * Discharge Template Management — upload form on top, templates list below.
 * Same pattern as Nurse Management and Bed Management.
 */
function DischargeTemplateManagement() {
  const [refreshList, setRefreshList] = useState(0);
  const [lastUploadedFileName, setLastUploadedFileName] = useState(null);

  return (
    <div>
      <DischargeTemplateUpload
        updateList={(fileName) => {
          setLastUploadedFileName(fileName || null);
          setRefreshList((n) => n + 1);
        }}
      />
      <DischargeTemplateList
        refreshList={refreshList}
        lastUploadedFileName={lastUploadedFileName}
      />
    </div>
  );
}

export default DischargeTemplateManagement;
